import { graphql } from "@/lib/gql/__generated__";

export const OptionStock_StockManagement_Query = graphql(/* GraphQL */ `
	query OptionStock_StockManagement($hotelID: ID!, $startDt: String!, $endDt: String!) {
		optionStock(hotelID: $hotelID, startDt: $startDt, endDt: $endDt) {
			id
			hotelID
			headers {
				date
				weekday
			}
			items {
				optionID
				subOptionID
				name
				isInSale
				stocks {
					date
					isAvailable
					isEditable
					remainNum
					soldNum
				}
			}
		}
	}
`);
